import { useParams, Link } from "react-router-dom";
import {
  Container,
  Section,
  Prose,
  buttonStyles,
} from "@comai-portal/design-system";
import { getLegalDoc } from "../content/legal";

/**
 * LegalPage — renders a canonical legal doc by slug on the design system. (CO 069)
 * Routes: /privacy, /terms, /acceptable-use, /cookies, /dpa map here via a
 * `slug` prop or the :slug param.
 */
export function LegalPage({ slug: slugProp }: { slug?: string }) {
  const params = useParams();
  const slug = slugProp ?? params.slug ?? "";
  const doc = getLegalDoc(slug);

  return (
    <div className="bg-paper text-ink dark:bg-ink dark:text-paper">
      <Section>
        <Container width="prose">
          {doc ? (
            <Prose>{doc.body}</Prose>
          ) : (
            <div className="text-center py-16">
              <h1 className="text-display-md mb-4">Document not found</h1>
              <p className="text-mute dark:text-mute-soft mb-8">
                That legal document doesn't exist.
              </p>
              <Link to="/" className={buttonStyles({ variant: "outline" })}>
                Back home
              </Link>
            </div>
          )}
        </Container>
      </Section>
    </div>
  );
}
